import { useRuntimeConfig } from 'nuxt/app';

export function useImageServer() {
	const { imageServerBaseUrl } = useRuntimeConfig().public;

	const resolveUrl = (id?: string) => {
		if (!id) {
			return '';
		}

		if (/^https?:\/\//i.test(id)) {
			return id;
		}

		return `${imageServerBaseUrl}/api/image/${id}`;
	};

	const resolveQueryUrl = (input?: string, params?: Record<string, string | number | boolean | undefined | null>) => {
		if (!input) {
			return '';
		}

		// Ensure absolute URL for proper parsing; fall back to resolveUrl for IDs
		const base = /^https?:\/\//i.test(input) ? input : resolveUrl(input);
		const url = new URL(base);

		Object.entries(params || {}).forEach(([key, val]) => {
			if (val === undefined || val === null) {
				return;
			}
			url.searchParams.set(key, String(val));
		});
		return url.toString();
	};

	return { resolveUrl, resolveQueryUrl };
}
